var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"py-12 mx-auto text-center"},[_c('div',{staticClass:"text-h6 pb-2"},[_vm._v("Project Type Breakdown")]),(!_vm.isTableLoading)?_c('Doughnut',{staticClass:"mx-auto",attrs:{"chart-id":"my-chart-id","options":_vm.chartOptions,"data":_vm.chartData,"height":"500","width":"500"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }